"use client";
import { motion } from "framer-motion";
import { Container, SectionSubHeading } from "@/components";
import { ServicesData } from "@/data/ServicesData";
import { fadeInUp, word, wordStagger } from "@/lib/animation/variant";

const HEADLINE = ["Design,", "build", "and", "ship", "—", "from"];

const STATS = [
  { value: "04", label: "Disciplines under one delivery team" },
  { value: "45+", label: "Startups powered through client work" },
  { value: "BDT 3M+", label: "Revenue scaled on a single storefront" },
  { value: "+40%", label: "Conversion lift on a rebuilt marketplace" },
];

const ServicesBanner = () => {
  return (
    <section className="w-full bg-background pt-16 pb-16 md:pb-24">
      <Container className="flex flex-col gap-8 px-4 lg:px-10">
        <div className="space-y-2">
          <motion.div
            custom={0}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
          >
            <SectionSubHeading
              subtitle={`Services — ${String(ServicesData.length).padStart(2, "0")} disciplines`}
            />
          </motion.div>

          <motion.h1
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={wordStagger}
            className="flex flex-wrap gap-x-[0.22em] text-4xl leading-[0.86] font-black tracking-tighter uppercase md:text-6xl xl:text-8xl"
          >
            {HEADLINE.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="inline-block overflow-hidden"
              >
                <motion.span variants={word} className="inline-block">
                  {item}
                </motion.span>
              </span>
            ))}
            <span className="inline-block overflow-hidden">
              <motion.span
                variants={word}
                className="inline-block text-primary"
              >
                one team.
              </motion.span>
            </span>
          </motion.h1>
        </div>

        <motion.p
          custom={1}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
          className="max-w-3xl text-base leading-relaxed font-medium text-muted-foreground md:text-xl"
        >
          Octarnal is a software and digital agency delivering brand identity,
          SaaS product design and development, high-performance websites and
          cinematic video for businesses that need strategy and delivery from
          the same people. Four disciplines, one accountable team, and no
          handoff where the work usually dies.
        </motion.p>

        <motion.dl
          custom={2}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
          className="mt-6 grid grid-cols-2 gap-px border border-black/10 bg-black/10 md:grid-cols-4"
        >
          {STATS.map((stat) => (
            <div key={stat.value} className="bg-background p-5 md:p-6">
              <dt className="text-2xl leading-none font-black tracking-tighter text-primary md:text-4xl">
                {stat.value}
              </dt>
              <dd className="mt-3 font-mono text-[10px] leading-relaxed tracking-[0.16em] uppercase text-muted-foreground">
                {stat.label}
              </dd>
            </div>
          ))}
        </motion.dl>
      </Container>
    </section>
  );
};

export default ServicesBanner;
